import React from 'react';
import { useIsMutating } from 'react-query';
import { UPDATE_PERSONAL_INFO_MK } from '../../../../../ProfileOPL/PersonalInfo/api/useUpdatePersonalInfoMutation';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { StickyFooter } from '../../../../../CommonComponents/OPL/StickyFooter/StickyFooter';
import { Button } from '../../../../../CommonComponents/OPL/Button/Button';
import { FORM_ID } from '../../../../../ProfileOPL/PersonalInfo/PersonalInfo.meta';

export const StepFooter = () => {
  const isUpdatingPersonalInfo = useIsMutating({ mutationKey: UPDATE_PERSONAL_INFO_MK }) > 0;

  const { clientId } = useRouteParams();

  return (
    <StickyFooter progress={0}>
      <Button
        size="large"
        variant="subtleInactive"
        onClick={() => {
          ADV.util.Router.go2('CharitableGivingWorkflowGoals', {
            clientId,
          });
        }}
      >
        Cancel
      </Button>

      <Button
        type="submit"
        size="large"
        rightIcon="fas fa-chevron-right"
        isLoading={isUpdatingPersonalInfo}
        form={FORM_ID}
        ml="16"
      >
        Save & Next
      </Button>
    </StickyFooter>
  );
};
